
export const common =  {
  '请求延时': '요청 지연',
  '操作成功': '작업 성공',
  '暂无数据': '데이터 없음',
  '请输入': '입력하십시오',
  'copyok': '복사 성공',
  'copyerror': '복사 실패',
};

export const tableList = {
  '跟单交易量':'복사 거래량',
  '跟单总交易量':'전체 복사 거래량',
  用户昵称: "사용자 닉네임",
  '持仓': '보유 포지션',
  '仓位': '포지션',
  '当前委托': '현재 의뢰',
  '当前计划': '현재 계획',
  '历史仓位': '과거 포지션',
  '账单': '계산서',
  '全部平仓': '전부 청산',
  '全部撤单': '전부 취소',

  '合约名称': '계약 이름',
  '创建时间': '생성 시간',
  '方向': '방향',
  '杠杆': '레버리지',
  '保证金': '증거금',
  '开仓价格': '진입 가격',
  '开仓均价': '평균 진입 가격',
  '全仓风险率': '풀 포지션 리스크',
  '预估爆仓价': '예상 청산 가격',
  '收益率': '수익률',
  '平仓价格': '청산 가격',
  '预计强平价': '예상 강제 청산 가격',
  '持仓数量': '보유 포지션 수',
  '张': '장',
  '风险率': '리스크 비율',
  '保证金率': '증거금 비율',
  '预计止盈价': '예상 익절 가격',
  '预计止损价': '예상 손절 가격',
  '浮动盈亏': '플로팅 손익',
  '平仓盈亏': '청산 손익',
  '盈亏': '손익',
  '委托数量': '의뢰 수량',
  '委托价格': '의뢰 가격',
  '成交价格': '체결 가격',
  '成交均价': '평균 체결 가격',
  '止盈价': '익절 가격',
  '止损价': '손절 가격',
  '执行价': '실행 가격',
  '触发条件': '트리거 조건',
  '操作': '조작',
  '手续费': '수수료',
  '平仓类型': '청산 유형',
  '类型': '유형',
  '数量': '수량',

  '逐仓做多': '포지션 롱',
  '逐仓做空': '포지션 숏',
  '全仓做多': '풀 포지션 롱',
  '全仓做空': '풀 포지션 숏',
  '永续合约': '퍼페츄얼 컨트랙트',

  '手动平仓': '수동 청산',
  '市价平仓': '시장 가격 청산',
  '限价平仓': '지정가 청산',
  '止盈': '익절',
  '止损': '손절',
  '手动撤销': '수동 취소',
  '自动减仓': '자동 감소 포지션',
  '强制减仓': '강제 감소 포지션',
  '强制平仓': '강제 청산',
  '资金不足系统撤单': '자금 부족으로 시스템 취소',
  '资金超限系统撤单': '자금 초과로 시스템 취소',
  '撤单': '취소',
  '平仓': '청산',
  '更多': '더 보기',
  '部分平仓': '부분 청산',
  '反向开仓': '반대 포지션 진입',
  '加仓': '포지션 추가',
  '一键平仓': '일괄 청산',
  '最新价': '최신 가격',
  '体验金平仓': '체험 자금 청산',
  '下单时间': '주문 시간',
  '交易类型': '거래 유형',
  '委托类型': '의뢰 유형',
  '成交类型': '체결 유형',
  '逐仓平多': '포지션 롱 청산',
  '逐仓开多': '포지션 롱 진입',
  '逐仓平空': '포지션 숏 청산',
  '逐仓开空': '포지션 숏 진입',
  '全仓平多': '풀 포지션 롱 청산',
  '全仓开多': '풀 포지션 롱 진입',
  '全仓平空': '풀 포지션 숏 청산',
  '全仓开空': '풀 포지션 숏 진입',
  '可平量为0': '청산 가능 수량이 0입니다',
  '激活价格': '트리거 가격',
  '状态': '상태',
  '未激活': '미활성화',
  '已激活': '활성화',
  '回调率': '리바운드 비율',
  '仓位ID': '포지션 ID',
};
export const dialog = {
  前往设置: '설정으로 이동',
  提示: '알림',
  确定: '확인',
  取消: '취소',
  确认要全部平仓吗: '시장가로 전체 청산하고 모든 의뢰를 취소하시겠습니까?',
  确认要全部撤单吗: '모든 의뢰를 취소하시겠습니까?',
  确认要一键平仓吗: '일괄 청산하시겠습니까?',
  确认要一键平仓: '일괄 청산하고 복제를 해제하시겠습니까?',
  确认要市价平仓吗: '시장가로 청산하시겠습니까?',
  确认要限价平仓吗: '지정가로 청산하시겠습니까?',
  需先设置总跟单账户: '먼저 총 복제 계정을 설정해야 합니다. 복제를 시작할 수 있습니다.',
  加仓: '추가 포지션',
  不能为空: '필수 입력란입니다.',
  必须为数字值: '숫자여야 합니다.',
  数字不能小于等于0: '0보다 작을 수 없습니다.',
  请输入正确的杠杆倍数: '올바른 레버리지를 입력하세요.',
  无法切换仓位模式: '포지션 모드를 전환할 수 없습니다.',
  当前账户没有权限: '현재 계정에 권한이 없습니다.',
  swap001: '포지션을 보유 중이므로 포지션 모드를 전환할 수 없습니다.',
  需全部平仓后可重新设置: '복제 포지션을 보유 중이므로 복제 금액 및 배율을 수정할 수 없습니다. 모든 포지션을 청산한 후 다시 설정할 수 있습니다.',
  按张数: '수량 단위로',
  按金额: '금액 단위로',
  按比例: '비율로',
  按价格: '가격으로',
  张: '장',
  预计加仓金额: '예상 추가 포지션 금액',
  预计加仓张数: '예상 추가 포지션 수량',
  持仓数量: '보유 포지션 수량',
  开仓价格: '진입 가격',
  确认要反向开仓吗: '반대 포지션으로 진입하시겠습니까?',
  预计平仓金额: '예상 청산 금액',
  预计平仓比例: '예상 청산 비율',
  预计平仓张数: '예상 청산 수량',
  比例不可以大于: '비율은 100%를 초과할 수 없습니다.',
  比例不可以小于: '비율은 0% 미만일 수 없습니다.',
  部分平仓: '일부 청산',
  确认撤单吗: '의뢰를 취소하시겠습니까?',
  确认要平仓吗: '청산하시겠습니까?',
  盈亏: '손익',
  当前止损价: '현재 손절 가격',
  预估止损价: '예상 손절 가격',
  亏损: '손실',
  止损修改: '손절 가격 수정',
  止损比例: '손절 비율',
  止损价格: '손절 가격',
  当前盈利价: '현재 익절 가격',
  预估止盈价: '예상 익절 가격',
  收益: '수익',
  止盈修改: '익절 가격 수정',
  止盈比例: '익절 비율',
  止盈价格: '익절 가격',
  请输入加仓数: '추가 포지션 수량을 입력하세요.',
  请输入金额: '금액을 입력하세요.',
  请输入止盈价格: '익절 가격을 입력하세요.',
  请输入止盈比例: '익절 비율을 입력하세요.',
  请输入止损价格: '손절 가격을 입력하세요.',
  请输入止损比例: '손절 비율을 입력하세요.',

  'BTC/USDT账户模式': 'BTC/USDT 계정 모드',
  账户模式: '계정 모드',
  调整仓位模式: '포지션 모드 조정',
  保证金模式: '증거금 모드',
  仓位模式: '포지션 모드',
  调整保证金模式: '증거금 모드 조정은 USDT 모든 계약에 적용됩니다.',
  调整仓位合并模式: '포지션 모드 조정은 USDT 모든 계약에 적용됩니다.',
  全仓模式: '풀 포지션 모드',
  仓位合并: '포지션 합병',
  逐仓: '단일 포지션',
  全仓: '풀 포지션',
  合仓: '포지션 합병',
  分仓: '포지션 분할',
  swap002: '단일 포지션 모드에서 사용자는 양방향 포지션을 보유할 수 있으며 공매도 포지션과 공매수 포지션의 위험은 별개로 계산됩니다. 사용자는 포지션 폭파 시 포지션 증거금만 잃을 것입니다. 사용자가 포지션을 수동으로 청산할 때, 공매도 포지션과 공매수 포지션에서 발생한 손실과 이익은 각 포지션의 증거금으로 즉시 결산됩니다.',
  全仓模式下所有仓位将共享合约账户的可用保证金: '풀 포지션 모드에서 모든 포지션은 계약 계정의 사용 가능한 증거금을 공유합니다. 강제 청산이 발생하면 모든 포지션과 사용 가능한 증거금을 잃을 수 있습니다. 포지션 위험을 주의하세요!',
  合仓提示: '',
  分仓提示: '',
  不再提示: '다시 표시하지 않음',

  biking合约用户使用协议: '바이킹 파생 상품 이용 약관',
  综述:
  '<b>1.요약</b><br><br>' +
  '<span>' +
  '1.1 퍼페츄얼 컨트랙트("서비스")는 "바이킹"이 출시한 가상 자산 파생 상품입니다. "바이킹"은 제품 설계 및 거래 플랫폼 운영 서비스를 책임집니다. ' +
  '바이킹 퍼페츄얼 컨트랙트를 사용하기 위해서는 《바이킹 퍼페츄얼 컨트랙트 사용자 사용 계약》("본 계약")을 읽고 준수해야 합니다. 각 조항의 내용을 주의 깊게 읽고 이해한 후 동의 또는 비동의를 선택하십시오. ' +
  '<br><br>' +
  '1.2 본 계약의 모든 조항을 이미 읽고 동의하지 않으면 바이킹 퍼페츄얼 컨트랙트 및 해당 서비스를 사용할 수 없습니다. 본 계약의 모든 조항을 읽고 동의한 행위와 본 서비스의 사용은 이미 본 계약의 제한에 동의한 것으로 간주됩니다.' +
  '</span>' +
  '<br><br>' +
  '<b>2. 서비스 이용 자격</b>' +
  '<br><br>' +
  '<span>2.1 이해하고 동의하십시오:' +
  '<br>' +
  '이미 "바이킹 서비스 약관"을 준수하기로 동의하셨으며, 해당 약관에서 정의한 "서비스"를 사용하는 자격이 있습니다;' +
  '<br>' +
  '본 계약은 귀하가 거주하는 국가 또는 지역의 법률과 충돌하지 않습니다;' +
  '<br>' +
  '귀하는 이 서비스에 예금된 가상 자산의 합법적인 소유자이며 이러한 가상 자산의 출처가 합법적임을 보증합니다.' +
  '<br><br>' +
  '2.2 이 서비스의 리스크를 이해하고 있음을 인정하십시오. 이러한 리스크에는 다음이 포함됩니다. 단, 이에 국한되지 않음: ' +
  '<br>' +
  '가상 자산 및 해당 파생 상품의 고가변동은 짧은 시간 내에 심각한 손실 또는 전액 손실을 초래할 수 있습니다.' +
  '</span>',
  我已阅读并同意上述协议: '상기 계약 내용을 읽고 동의합니다.',

  调整杠杆: '레버리지 조정',
  杠杆倍数: '레버리지 배수',
  当前杠杆倍数最大可开: '현재 레버리지 배수 최대로 개장할 수 있습니다:',
  '当前仓位所需保证金：': '현재 포지션에 필요한 증거금:',

  交易单位切换: '거래 단위 전환',
  成交类型切换: '체결 유형 전환',
  限价: '지정가',
  市价: '시장가',
  数字范围必须在: '숫자는 1에서 100 사이어야 합니다.',
  请输入平仓数: '청산할 수량을 입력하세요.',
  请输入平仓比例: '청산 비율을 입력하세요.',
  请输入整数: '정수를 입력하세요.',
  以当前最优价格交易: '현재 최적가로 거래합니다.',
  请输入格式正确的杠杆倍数: '올바른 형식의 레버리지 배수를 입력하세요.',
  杠杆倍数提示: '현재 레버리지 배수가 높습니다. 리스크에 주의하세요.',
  下单二次确认: '주문 이중 확인',
  平仓二次确认: '청산 이중 확인',
  下单确认: '주문 확인',
  二次确认不展示: '다시 표시하지 않음(설정에서 다시 시작할 수 있음)',
  切换交易单位: '거래 단위 전환',
  偏好设置: '기본 설정',
  仓位止盈止损: '포지션 익절 및 손절',
  移动止盈止损: '이동 익절 및 손절',
  止盈止损提示:
  '이동 익절 및 손절은 포지션 청산에 사용됩니다. 이는 시장이 유리한 방향으로 진행될 때, 트레이더 수익을 보호하기 위해 트레이더가 설정한 주문을 시장으로 보냅니다. 시장 가격이 트레이더가 설정한 전액 익절 또는 손절 주문의 활성 가격에 도달하면 주문이 활성화됩니다. 시장 가격이 트레이더가 설정한 전액 익절 또는 손절 주문의 최고(또는 최저) 가격에 설정된 (1±반환 비율)에 도달하면 주문이 트리거되고 체결 가격은 설정된 최고(또는 최저) 가격의 (1±반환 비율)입니다.',
  最新成交价: '최신 체결가',
  设置止盈: '익절 설정',
  设置止损: '손절 설정',
  预计盈利: '예상 수익',
  预计亏损: '예상 손실',
  调整保证金: '증거금 조정',
  增加: '증가',
  减少: '감소',
  最大: '최대',
  当前仓位保证金: '현재 포지션 증거금',
  最大可增加: '최대 증가량',
  最大可减少: '최대 감소량',
  调整后参考强评价: '조정 후 참고 강제 평가 가격',
  请输入保证金: '증거금을 입력하세요.',
  强平价格: '강제 청산 가격',
  开仓数量: '개장 수량',
  计算: '계산',
  计算结果: '계산 결과는 참고용입니다.',
  回调率: '리바운드 비율',
  请输入回调率: '리바운드 비율을 입력하세요.',
  仓位数量: '포지션 수량',
  激活价: '활성 가격',
  请输入激活价: '활성 가격을 입력하세요.',
  激活做多提示: '롱 방향의 경우 최신 체결가보다 높아야 합니다.',
  激活做空提示: '숏 방향의 경우 최신 체결가보다 낮아야 합니다.',
};
export const codeInfo = {
  永续合约: '영속',
  标记价格: '마킹 가격',
  指数价格: '지수 가격',
  指数价格提示: '해당 계약의 실시간 지수 가격입니다. 이 가격은 사용자의 포지션의 예상 청산 가격 계산에 사용되며, 계약의 최신 체결 가격과 다를 수 있습니다. 가격 조작을 방지하기 위해 조정될 수 있습니다.',
  '24H最高': '24시간 최고가',
  '24H最低': '24시간 최저가',
  资金费率: '당기 자금 비율',
  距费用结算: '당기 비용 결제까지 남은 시간',
  我的赠金: '나의 선물금',
};
export const panKou = {
  交易深度: '매수/매도 장부',
  实时成交: '실시간 거래',
  张: '건',
  保证金: '보증금',
  价格: '가격',
  数量: '수량',
  时间: '시간',
  累计: '누적',
};
export const placeOrder = {
  立即去玩: '지금 플레이하러 가기',
  全仓: '전액',
  逐仓: '증거금',
  杠杆: '레버리지',
  开多: '롱',
  开空: '숏',
  市价委托: '시장가',
  限价委托: '지정가',
  计划委托: '플랜',
  价格: '가격',
  数量: '수량',
  限价: '지정가',
  市价: '시장가',
  止盈止损: '이익 실현/손절',
  张: '건',
  开仓价: '진입 가격',
  触发价: '트리거 가격',
  执行价: '실행 가격',

  收益: '수익',
  按比例设置: '비율로 설정',
  按价格设置: '가격으로 설정',
  亏损: '손실',

  swap003: '매수/롱',
  swap004: '매도/숏',
  买入: '매수',
  卖出: '매도',
  做多: '롱',
  做空: '숏',
  可用: '사용 가능',
  可做多: '롱 가능',
  可做空: '숏 가능',

  资产: '자산',
  持仓保证金: '포지션 보증금',
  未实现盈亏: '미실현 손익',
  净值: '순자산',
  可用保证金: '가용 보증금',
  账户余额: '계정 잔액',
  风险率: '위험률',

  合约信息: '계약 정보',
  指数来源: '지수 소스',
  合约面值: '계약 가치',
  资金费率: '자금 비율',
  最大杠杆: '최대 레버리지',
  下单方向可开张数的: '주문 방향으로 개장할 수 있는 장 수',

  立即注册: '회원가입',
  登录: '로그인',
  swap005: '자산(영속 계약)',
  登录以查看: '로그인하여 확인하세요',

  请输入数量: '수량을 입력하세요',
  请输入价格: '가격을 입력하세요',
  请输入限价: '지정가를 입력하세요',
  请输入止盈止损: '이익 실현/손절을 입력하세요',
  '止损率不能大于90%': '손절 비율은 90%를 초과할 수 없습니다',
  止损价格不能大于: '손절 가격은 최대',
  开通合约账号: '계약 계정 개설',
  账号冻结: '계정 동결',
  '止盈率不能大于1000%': '이익 실현 비율은 1000%를 초과할 수 없습니다',
  请输入触发价: '트리거 가격을 입력하세요',
  保证金: '보증금',
  体验金: '체험금',
  不使用体验金: '체험금 사용 안 함',
  查看详情: '상세 보기',
  委托保证金: '위탁 보증금',
  币: '코인',
  计算器: '계산기',
  划转: '전이'
};
export const codelist = {
  搜索: '검색',
  全部: '전체',
  交易对: '거래 쌍',
  最新价: '최신 가격',
  涨幅: '등락폭',
  自选: '관심',
  添加自选成功: '관심 추가됨',
  取消自选成功: '관심 해제됨'
};
export const merchandiser = {
  我的实盘: "내 실전",
  与优秀的交易员共同赚钱: "우수한 거래자와 함께 수익 창출",
  code_00051: "카피 트레이딩 커뮤니티",
  个人中心: '개인 센터',
  更多服务: '더 많은 서비스',
  钱包: "지갑",
  衍生品: '파생 상품',
  跟单设置: '복사 설정',
  跟单: '복사',
  跟单提示: '데이터는 매시간 업데이트됩니다',
  我的跟单: '내 복사',
  成为交易员: '거래자로 등록',
  综合排名: '종합 순위',
  收益率: '수익률',
  近3周收益: '최근 3주 수익',
  近3周胜率: '최근 3주 승률',
  总收益: '총 수익',
  累计收益率: '누적 수익률',
  累计跟随人数: '누적 복사자 수',
  跟随中: '복사 중',
  AUM: 'AUM',
  当前跟谁: '현재 복사 중',
  搜索交易员: '거래자 검색',
  满员: '정원 초과',
  申请成为交易员: '거래자로 신청',
  手机号: '휴대폰 번호',
  邮箱: '이메일',
  请输入邮箱: '이메일을 입력하세요',
  邮箱错误: '올바른 이메일을 입력하세요',
  请输入手机号: '휴대폰 번호를 입력하세요',
  手机号错误: '올바른 휴대폰 번호를 입력하세요',
  请输入正确数值: '올바른 값을 입력하세요',
  申请交易员提示文案: '거래자로 등록하면 복사 수익을 얻을 수 있습니다',
  跟单确认: '복사 확인',
  我已同意跟单协议: '본인은 복사 계약에 동의합니다',
  跟单协议: '《복사 계약》',
  申请跟单提示文案: "본 계약은 당신(이하 '당신' 또는 '당신의')과 코인왕과의 사이에 체결되었습니다. 당신이 코인왕 플랫폼 또는 하위 웹 사이트(wang.com), 모바일 애플리케이션을 통해 제공되는 모든 서비스 또는 코인왕 또는 하위 계열사의 다른 관련 서비스를 이용하거나 본 서비스에 접근함으로써, 당신은 본 서비스 이용약관(이하 '본 이용약관'이라 함) 및 플랫폼에서 공지하는 개인 정보 보호 정책의 모든 조항과 조건을 읽었으며 이해하고 동의한 것으로 간주됩니다. 또한, 일부 기능을 사용할 때에는 해당 기능에 적용되는 별도 조항 및 조건을 준수해야 할 수 있습니다.",
  申请跟单提示文案1: "1. 거래자를 따라서 거래하면 손실 위험이 있습니다. 이 위험은 복사 사용자가 스스로 부담해야 합니다.",
  申请跟单提示文案2: "2. 코인왕 플랫폼은 복사자가 이러한 기간 동안 계약 거래에 사용할 계약 계정을 사용할 수 있도록 지원합니다. 복사자가 직접 포지션을 열 경우 계약 거래를 위해 계약 계정으로 이동할 수 있으며,이 기간에는 복사 계정에 영향을주지 않습니다.",
  申请跟单提示文案3: "3. 복사 성공 후, 거래자가 새로운 포지션을 열 경우에만 복사가 이루어집니다. 이미 보유한 포지션은 복사되지 않습니다. 언제든지 복사를 취소할 수 있으며, 복사를 취소해도 이미 복사된 주문에는 영향을주지 않으며 수동으로 평가할 수 있습니다.",
  申请跟单提示文案4: "4. 복사하는 동안 포지션을 조정하면 복사 모드가 해제됩니다.",
  申请跟单提示文案5: "5. 거래자가 포지션을 청산한 후 이익이 발생하면 해당 주문의 이익의 12%가 복사 거래자에게 상금으로 지급됩니다.",
  申请跟单提示文案6: "6. 거래자를 따라 주문을 내면 손실 위험이 있으므로 신중하게 선택하고 리스크 관리에 주의하고 복사 리스크를 이해하십시오.",
  申请跟单提示文案7: "7. 복사하는 거래자의 주문이 위반으로 판명되어 거래자 자격이 취소되면 새 포지션을 열 수 없으며, 이미 복사된 포지션은 영향을받지 않지만 즉시 복사 모드에서 해제됩니다.",
  申请跟单提示文案8: "8. 거래자는 복사 사용자를 제거 할 권리가 있습니다. 제거 된 후 새 포지션을 열 수 없으며 이미 복사 된 포지션은 영향을받지 않습니다.",
  搜索您的国家名或国家区号: '국가 이름 또는 국가 코드를 검색하세요',
  我已同意成为交易员: '거래자로 등록에 동의합니다',
  请勾选: '체크해주세요',
  申请交易员失败提示: '현재 거래를 따라가고 있으므로 거래자로 등록할 수 없습니다. 모든 거래를 중지한 후 다시 신청하십시오.',
  我知道了: '알겠습니다',
  今日收益: '오늘 수익',
  累计收益: '누적 수익',
  交易员分成: '거래자 수수료',
  待结算分成: '미결제 수수료',
  已结算分成: '결제된 수수료',
  当前跟单: '현재 복사',
  历史跟单: '과거 복사',
  我的交易员: '내 거래자',
  编辑: '편집',
  平仓均价: '평균 청산 가격',
  持仓均价: '평균 보유 가격',
  开仓时间: '개장 시간',
  平仓时间: '청산 시간',
  预估暴仓价: '예상 청산 가격',
  交易员: '거래자',
  详情: '상세 정보',
  仓位ID: '포지션 ID',
  空位提醒: '빈 자리 알림',
  空位提醒内容: '이 거래자의 복사 인원이 가득 찼습니다. 거래자가 정원 초과 상태가 아닐 때 한 번의 알림이 전송됩니다.',
  当前跟随: '현재 복사',
  跟随人数数据: '{v1}/{v2} 명',
  跟随人数: '복사 인원',
  总权益: '총 자산',
  带单合约: '본인 계약',
  交易数据: '거래 데이터',
  交易笔数: '거래 횟수',
  盈利笔数: '수익 횟수',
  亏损笔数: '손실 횟수',
  扛单比例: '취급비율',
  平均扛单率: '평균 취급율',
  最大扛单率: '최대 취급율',
  订单: '주문',
  跟随者: '복사자',
  跟随者收益: '복사자 수익',
  跟随用户: '복사 사용자',
  跟随总额: '총 복사 금액',
  跟随收益: '복사 수익',
  交易员订单本金: '거래자 주문 자본금',
  当前带单: '현재 본인',
  历史带单: '과거 본인',
  跟单数据统计: '복사 거래 통계',
  不用了: '취소',
  设置提醒成功: '알림 설정 완료',
  我的带单: '내 본인',
  查看主页: '홈페이지 보기',
  利润分成比例: '수익 분배 비율',
  跟随交易员: '거래자 복사',
  仓位类型: '포지션 유형',
  指定杠杆: '지정된 레버리지',
  请输入杠杆: '레버리지를 입력하세요',
  单笔倍率: '단일 배수',
  单笔金额: '단일 금액',
  固定额度: '고정 금액',
  请输入单笔金额1: '5U보다 작은 고정 금액을 입력하세요',
  请输入单笔金额: '{v1}{v2} 사이의 단일 복사 금액을 입력하세요',
  请输入单笔倍率: '{v1}{v2} 사이의 복사 비율을 입력하세요',
  每次下单折合U: '개장시 {v1} USDT를 보증금으로 투입합니다',
  每次下单倍数: '각 주문은 거래자 주문 수량의 {v1}배입니다',
  倍率: '배수',
  跟单本金: '복사 자본금',
  总跟单保证金: '총 복사 보증금',
  请输入跟单本金: '복사 자본금을 입력하세요',
  资产账户: '자산 계정 {v1} USDT',
  合约账户: '계약 계정 {v1} USDT',
  风险控制: '리스크 제어',
  设置: '설정',
  保存: '저장',
  取消跟随: '복사 취소',
  移除跟随: '복사 제거',
  交易员保证金: '거래자 보증금',
  请输入交易员保证金: '거래자 보증금을 입력하세요',
  风险设置提示: '이 거래자의 포지션 자본금이 이 값에 도달하면 주문이 중단됩니다',
  关闭带单: '본인 종료',
  我的跟随者: '내 복사자',
  带单设置: '본인 설정',
  预计利润分成: '예상 수익 분배',
  利润分成: '수익 분배',
  开启成功: '성공적으로 열림',
  开启失败: '실패',
  关闭成功: '성공적으로 닫힘',
  关闭失败: '실패',
  '确认取消跟随吗？': '복사를 취소하시겠습니까?',
  条件一: '계약이 포지션을 보유하지 않고 현재 미체결 주문 및 예약 주문이 없어야 함',
  条件二: '계약 계정 잔액 ≥ {v} USDT여야 함',
  条件三: '계약이 포지션을 보유하지 않아야 함',
  最大回撤: '최대 하락폭',
  平均持仓时间: '평균 보유 기간',
  正在跟随: '복사 중',
  历史跟随: '과거 복사',
  累计跟单: '총 복사',
  累计分成: '총 수수료',
  笔: '건',
  上一页: '이전 페이지',
  下一页: '다음 페이지',
  返回: '돌아가기',
  今日预估收益: '오늘 예상 수익',
  账户权益: '계정 자산',
  将账户权益展示在个人信息页面: '계정 자산을 개인 정보 페이지에 표시합니다',
  带单本金: '복사 자본금',
  每次开仓均会展示带单本金: '모든 거래에서 복사 자본금이 표시됩니다',
  隐藏挂单价: '미체결 주문 가격 숨기기',
  带单币对: '복사 통화 쌍',
  入住时间: '가입 날짜',
  保存成功: '저장 성공',
  取消成功: '취소 성공',
  设置成功: '설정 성공',
  跟单合约: '복사 계약',
  历史委托: '과거 주문',
  成交数量: '체결 수량',
  触发时间: '트리거 시간',
  开启带单: '복사 시작',
  账户已冻结: '계정이 동결되었습니다. 고객 서비스에 문의하세요',
  审核中: '심사 중',
  小时: '{v} 시간',
  累计分润: '총 수익',
  今日预估分润: '오늘 예상 수익',
  交易协议: '거래 계약',
  带单协议: '복사 계약',
  追加跟单本金: '추가 복사 자본금',
  提示: '알림:',
  提示信息: '수익은 매일 0시에 정산되며 1시 이전에 완료됩니다. 정산 후 자동으로 계약 계정에 입금됩니다. 정산 기간에 복사 포지션이 있으면 다음 거래일에 정산됩니다',
  合约跟单: '계약 복사',
  跟单文字: 'Biking에서 세계 최고의 거래자와 함께 수익을 창출하세요',
  查看牛人实盘: '유명한 트레이더 실시간 거래 보기',
  捕捉市场信号: '시장 신호 포착',
  复制高手收益: '전문가 수익 복사',
  跟单指南: '거래 복사 가이드',
  跟单广场: '복사 광장',
  跟单总收益: '총 복사 수익',
  丰厚分润收入: '풍부한 분담 수익',
  更多平台曝光: '다양한 플랫폼 노출',
  专属交易徽章: '특별 거래 배지',
  成为Biking带单交易员: 'Biking 복사 거래자로 등록',
  享受Biking带单交易员的独家福利: 'Biking 복사 거래자의 독점 혜택을 누리세요',
  平台奖励: '플랫폼 보너스 12%',
  联系方式: '연락처',
  简介: '개요',
  请输入简介: '개요를 입력하세요',
  交易能力证明: '거래 능력 증명(선택 사항)',
  选择周期: '30일 이상의 수익률 곡선, 거래 데이터 통계 등을 선택하세요. 업로드하지 않으면 여러분의 거래 기록이 자동으로 검토됩니다. 최대 3개의 이미지를 업로드할 수 있으며 각 이미지 크기는 10MB를 초과할 수 없습니다.',
  我已阅读并同意: '내용을 확인하고 동의합니다:',
  跟单交易服务条款: '거래 복사 서비스 약관',
  立即申请: '지금 신청',
  请输入联系方式: '연락처를 입력하세요',
  联系方式不正确: '올바른 연락처를 입력하세요!',
  邮箱格式不正确: '올바른 이메일 형식이 아닙니다',
  请输入简介信息: '개요 정보를 입력하세요',
  请确认勾选协议: '약관에 동의하세요',
  上传头像图片限制: '프로필 이미지 크기는 10MB를 초과할 수 없습니다!',
  最大限制: '현재 최대 제한은 3개 파일입니다',
  带单交易员招募中: '복사 거래자 모집 중, 즉시 12% 복사 분담 수익을 즐기세요',
  跟单成功: '복사 성공',
  昵称: '닉네임',
  请输入昵称: '닉네임을 입력하세요',
  申请交易员已提交: '거래자 신청이 제출되었습니다. 심사를 기다리세요'
};
export const hyy = {
  bkt: "사용 안 함",
  wqdkt: "확실히 사용하겠습니다",
  kt12: "1. 디지털 자산 계약 거래의 기본 지식, 관련 위험 및 파생 상품 거래와 관련된 비즈니스 규칙 등을 자세히 이해해야 합니다.",
  kt13: "2. 이 리스크 공시문의 위험 사항은 열거적인 것일 뿐이며, 디지털 자산 파생품 거래의 모든 위험 요인을 상세히 나열하지는 못했습니다. 투자자가 디지털 자산 파생품 거래에 참여하기 전에는 다른 잠재적 위험 요인을 신중하게 이해하고 파악해야 합니다.",
  kt14: "3. 투자자가 자신의 실제 상황, 즉 위험 감수 능력 등을 고려하여 이 계약 거래에 참여할지 여부를 신중하게 결정하고 자신의 디지털 자산을 합리적으로 구성할 것을 진심으로 바랍니다.",
  kt0: "소중한 사용자님:",
  kt1: "아직 계약 계정 및 계약 거래 권한이 활성화되지 않았습니다. 아래 내용을 자세히 읽은 후 활성화 여부를 결정하십시오:",
  kt2: "1. 계약 시장에서 거래하는 경우 시장 가격 추세가 불리할 경우 포지션 보증금이 부족해지면 BiKing 영속 계약은 시스템 규정에 따라 강제 청산 명령을 수행하고 강제 청산 내역을 공개합니다.",
  kt3: "2. 당사의 영속 계약 비즈니스 규칙을 신중하게 읽고 준수해야 하며 계약 메커니즘 및 작동 원리, 시장의 여러 위험을 이해해야 합니다.",
  kt4: "4. BiKing 영속 계약은 계약 거래 시스템에 연결됩니다. 사용자 포지션의 손익은 계약 시장의 변동에 따라 변동되며 큰 손실이 발생할 경우 계약 거래 시스템에서 청산이 발생할 수 있습니다. 사용자는 계약 시장의 변동에 따라 시스템을 통해 자신의 거래 행위를 적시에 결정하고 손익을 부담해야 합니다. 따라서 BiKing은 어떠한 가정 또는 보증 책임을 부담하지 않습니다.",
  kt5: "5. 일부 극단적인 시장 상황에서는 보유한 미청산 계약을 청산하기 어려울 수 있습니다. 예를 들어, 사용자의 수익이 전체 계약 시장에서 유효한 레버리지 PnL의 첫 번째로 순위를 차지하고 대응 포지션 표가 손실을 상환하기에 충분하지 않은 경우 등입니다.",
  kt6: "6. 디지털 자산 파생품 거래는 특정 법률 관할 구역의 정책 감독 위험에 직면할 수 있으며, 거래 전에는 거래 지역의 정책 감독 배경을 신중히 고려하고 판단해야 합니다. 관련 국가 및 지역의 법률, 규정, 정책 변경, 계약 거래소 거래 규칙 변경, 비상 조치 등으로 인해 BiKing은 사전에 선언을 통해 사용자의 보유한 미청산 계약이 계속 보유되지 못할 수 있습니다. 그러나 보증금 및 이익 잔액은 여전히 현금으로 지급됩니다.",
  kt7: "7. 비 플랫폼 측이 제어할 수 없는 이유로, 지진, 홍수, 화재 등의 불가항력 요인 또는 컴퓨터 시스템, 통신 시스템 장애 등으로 인해 사용자의 지시가 체결되지 않거나 전부 체결되지 않을 수 있으며, 이로 인한 손실은 사용자 본인이 부담할 수 있습니다.",
  kt8: "8. '헤지 거래'도 투기 거래와 마찬가지로 가격 변동에 따른 위험에 직면합니다.",
  kta9: "9. 실명 인증을 수행하지 않거나 Google 인증을 바인딩하지 않았거나 계정을 타인에게 대여하는 경우 계약 보증금의 안전성에 영향을 줄 수 있습니다",
  kta10: "3. 일부 극단적인 시장 상황에서는 보유한 미청산 계약을 청산하기 어려울 수 있습니다. 예를 들어, 사용자의 수익이 전체 계약 시장에서 유효한 레버리지 PnL의 첫 번째로 순위를 차지하고 대응 포지션 표가 손실을 상환하기에 충분하지 않은 경우 등입니다.",
  kt9: "위험을 자세히 읽고 이해했으며 수용하겠습니다",
  kt10: "계약 계정 및 계약 거래 권한 활성화",
  zjhz: "자금 이체",
  ljhz: "즉시 이체",
  qx: "이체 취소",
  khz: "이체 가능",
  qxz: "선택하세요",
  bz: "통화",
  c: "에서",
  zz: "으로 이동",
  sl: "수량",
  qb: "전부",
  ktcg: "활성화 성공",
  ktsb: "활성화 실패",
  hzcg: "이체 성공",
  hzsb: "이체 실패",
  wyyd: "", //읽은 것을 선택하지 않은 경우의 힌트 문구
  tc: "종료",
  warning1: "통화를 선택하세요",
  warning2: "이체 출금 계정을 입력하세요",
  warning3: "이체 입금 계정을 입력하세요",
  warning4: "이체할 수량을 초과하지 않는 수를 입력하세요",
  gb: "닫기",
  openSuccess: "계약 거래가 활성화되었습니다",
  openSuccessTip: "계약 계정으로 자금을 이체하세요",
  warning5: "소수점 4자리까지 입력하세요",
  not_get_nm: "죄송합니다. 이벤트가 종료되어 이번 이체로는 NFT를 받을 수 없습니다",
}

export const invite = {
  "yqfy": "邀请返佣",
  "yj1": "分享邀请链接、邀请海报或推荐码",
  "yj2": "邀请朋友注册并交易",
  "yj3": "坐享交易手续费返佣",
  "yqm": "我的邀请码：",
  "yqlj": "我的邀请链接：",
  "fz": "复制",
  "fzcg": "复制成功",
  "fzsb": "复制失败",
  "dlck": "登录后查看",
  "rs": "已邀请人数",
  "ljbb": "累计币币交易返佣({flag}）",
  "ljeft": "累计ETF交易返佣({flag}）",
  "ljhy": "累计合约交易返佣({flag}）",
  "yhm": "用户名",
  "sfsm": "是否实名",
  "tjsj": "推荐时间",
  "zsy": "总收益({flag}）",
  "s": "是",
  "f": "否",
  "djjz": "点击加载更多",
  "ckmx": "查看详情",
  "pm": "排名",
  "zyqr": "月邀请人数",
  "zfyj": "月返佣金额({flag}）",
  "ckbd": "查看完整榜单",
  "rlues1": "邀友注册，长期返佣，坐享收益。",
  "rlues2": "邀请好友注册即可建立邀请关系，好友进行币币、杠杆ETF交易可获得好友手续费返佣，邀请返佣收益无上限。",
  "rlues3": "邀请返佣规则&比例",
  "jylx": "交易类型",
  "yqrfy": "邀请人返佣",
  "yqgxyxq": "邀请关系有效期",
  "sixMonth": "6个月",
  "yj": "永久",
  "bbjy": "币币交易",
  "hyjy": "合约交易",
  "etfjy": "杠杆ETF交易",
  "gxsj": "每周一更新数据",
  "xts": "小贴士",
  "ts1": "好友注册时必须填写您的邀请码，方视作你的成功邀请哦！",
  "ts2": "用手机扫描左边二维码，链接转发给用户，可以快速邀请用户。",
  "tgzsy": "推广总收益({flag}）",
  "cz": "操作",
  "fymx": "返佣明细 >",
  "zwsj": "暂无记录",
  "yh": "用户",
  "hqyj": "获得邀请返佣金",
  "ysm": "已实名",
  "wsm": "未实名",
  "hyfymx": "好友返佣明细",
  "fylx": "返佣类型",
  "fyje": "返佣金额",
  "fysj": "返佣时间",
  "mxsyb": "明细收益表",
  "zwjy": "该好友暂未交易，无手续费返佣",
  "bczxc": "保存至相册",
  "rlues4": "受网络波动影响，部分用户会出现佣金延迟到账的情况，请耐心等待。",
  "moreRules": "查看详细规则"
};




// WEBPACK FOOTER //
// ./src/i18n/lang/merchandiser/kr.js